// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Business State
// -------------------------------
export interface BusinessState extends EntityState<any> {
  common?: any;
  business?: any;
}

// -------------------------------
//  Business Adapter
// -------------------------------
export const businessAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Business Initial State
// -------------------------------
export const initialState: BusinessState = businessAdapter.getInitialState(
  {
    common: null,
    business: null,
  },
);
